import type { ReportGroup } from '../types';
import { overview } from './overview';
import { products } from './products';

export const registrations = {
  key: 'registrations',
  label: 'Registrations',
  isEnabled: ({ isRegistrationEnabled }) => isRegistrationEnabled,
  filters: {},
  reports: [overview, products],
} as const satisfies ReportGroup;
